import { render } from "./Detail.vue?vue&type=template&id=2a6ab1e3&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=2a6ab1e3&scoped=true&lang=css"
import "./Detail.vue?vue&type=style&index=1&id=2a6ab1e3&lang=scss"

import exportComponent from "D:\\Xoan\\asp-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6ab1e3"]])

export default __exports__